import { gsap } from 'gsap'

export default {
	namespaced: true,
	state: {
		isFullVideoModalOpen: false,
		monitorRefreshRate: 60,
		fullVideoModalSrc: '',
		cursorHover: ''
	},

	actions: {},

	mutations: {
		fullModalOpened(state, value) {
			state.isFullVideoModalOpen = value
		},
		monitorRefreshRate(state, value) {
			state.monitorRefreshRate = value
		},
		fullModalSrc(state, value) {
			state.fullVideoModalSrc = value
		},
		cursorHover(state, value) {
			state.cursorHover = value
		}
	},

	getters: {
		fullVideoOpenModal(state) {
			return state.isFullVideoModalOpen
		},
		fullModalSrc(state) {
			return state.fullVideoModalSrc
		},
		monitorRefreshRate(state) {
			return state.monitorRefreshRate
		},
		cursorHover(state) {
			return state.cursorHover
		}
	}
}
